import React, { useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'

import ScreenLoading from '../../components/ScreenLoading'
import useGetServices from 'containers/services/useGetServices'
import useQuery from 'containers/useQuery'

const LandingAddAccount = () => {
  const query = useQuery()
  const { serviceId } = useParams()

  let history = useHistory()
  const { getServices } = useGetServices()

  useEffect(() => {
    let serviceUuidsById = {}
    const getData = async () => {
      const allServices = await getServices()

      allServices.forEach((service) => {
        serviceUuidsById[service.id] = service.uuid
      })
    }

    const redirect = async () => {
      await getData()
      if (query.get('error')) {
        let error = query.get('error')
        if (query.get('error_description')) {
          error = query.get('error_description')
        }
        history.push({
          pathname: `/organization/${localStorage.getItem(
            'currentOrganization'
          )}/sources/add`,
          state: {
            error: error,
          },
        })
      } else {
        try {
          // state is a b64 encoded string of a python dict with keys context and validation. 
          // we try decode it and extract the keys and values to a object called state
          const state = JSON.parse(atob(query.get('state')))
          const environmentDomain = state.context
          const isEnvironment = environmentDomain.match("maya-pr-[a-zA-Z0-9]+-frontend")
          if ((window.location.hostname.match(".+\.mayabackup\.com") !== null && window.location.hostname.split('.',1)[0] === 'maya-staging-frontend') && isEnvironment) {
            // Redirect to the pr evenrinment to complete tthe integration
            const redirectTo = new URL(`https://${environmentDomain}.mayabackup.com`)
            redirectTo.pathname = window.location.pathname
            redirectTo.search = window.location.search
            window.location.replace(redirectTo)
            return
          }
        } catch (e) {
          console.error(e)
        }

        localStorage.setItem('redirectState', query.get('state'))
        localStorage.setItem('redirectCode', query.get('code'))
        let serviceUuid = serviceUuidsById[serviceId]
        if (serviceId === 'search_console') {
          localStorage.setItem('redirectServiceId', 'google_search_console')
          serviceUuid = serviceUuidsById['google_search_console']
        } else {
          localStorage.setItem('redirectServiceId', serviceId)
        }
        localStorage.setItem('redirectServiceUuid', serviceUuid)
        history.push(
          `/organization/${localStorage.getItem(
            'currentOrganization'
          )}/integrations/add`
        )
      }
      // eslint-disable-next-line
    }

    redirect()
  }, [getServices, history, query, serviceId])

  return <ScreenLoading />
}

export default React.memo(LandingAddAccount)
